import { addKeydownListener } from "shared/services/shortcuts";

export default () => {
  addKeydownListener();
};
